<template>
  <div id="myDateShow">
    <div class="title">查看 心坞栈资料</div>
    <div id="dataShow">
      <div class="line">
        <div class="key">心坞栈类型</div>
        <div class="value">{{coveShed.coveShedClassify}}</div>
      </div>
      <div class="line">
        <div class="key">心坞栈名称</div>
        <div class="value">{{coveShed.coveShedName}}</div>
      </div>
      <div class="line">
        <div class="key">联系人</div>
        <div class="value">{{coveShed.coveShedUsername}}</div>
      </div>
      <div class="line">
        <div class="key">联系人手机号</div>
        <div class="value">{{coveShed.coveShedPhone}}</div>
      </div>
      <div class="line">
        <div class="key">常用邮箱</div>
        <div class="value">{{coveShed.coveShedEmail}}</div>
      </div>
      <div class="line">
        <div class="key">联系地址</div>
        <div class="value">{{coveShed.coveShedAddress}}</div>
      </div>
      <div class="line">
        <div class="key">入驻时间</div>
        <div class="value">{{coveShed.coveShedInTime}}</div>
      </div>
      <div class="line">
        <div class="key">最后更新时间</div>
        <div class="value">{{coveShed.coveShedUpdateTime}}</div>
      </div>
      <div class="line">
        <div class="key">营业时间</div>
        <div class="value">{{coveShed.workTime}}</div>
      </div>
      <div class="line">
        <div class="key">覆盖的坞栈社区</div>
        <div class="value">
          <div class="tag" v-for="(item,index) in coveShed.coveShedAddresses">
            <span>{{item.labelTwoName}}</span>
          </div>
        </div>
      </div>
      <div class="line">
        <div class="key">合作协议书</div>
        <div class="value">{{coveShed.agreementName}}</div>
      </div>
      <div class="line">
        <div class="key"></div>
        <div class="value">
          <el-link download="协议书" :underline="false" :href="coveShed.agreementUrl">
            <el-button type="success" size="small" @click="aaa">下载协议书</el-button>
          </el-link>
        </div>
      </div>
      <div class="line"></div>

    </div>
    <div class="but">
      <el-button type="danger" size="small" @click="backClick">返回</el-button>
    </div>
  </div>
</template>

<script>
  import {getCoveShedById,newVue} from "../../network/coveShed";

  export default {
    name: "coveShedData",
    components: {},
    data(){
      return{
        coveShedId:"",
        coveShed:{}
      }
    },
    methods:{
      aaa(){},
      backClick(){
        this.$router.push("../list");
      },
    },
    created() {
      newVue.obj = this;

      this.common.HeaderLocationTwo.href =  "/coveShed/list";
      this.common.HeaderLocationTwo.name = "心坞栈列表"
      this.common.HeaderLocationThree.name = "心坞栈资料详情"
      this.coveShedId = this.$route.params.id;

      getCoveShedById(this.coveShedId).then(res => {
        this.coveShed = res.data
      })
    }
  }
</script>

<style scoped>
  @import "../../assets/css/data.css";

  .tag {
    display: inline-block;
    height: 30px;
    background-color: #67c23a;
    border-color: #e9e9eb;
    color: white;
    box-sizing: border-box;
    margin: 2px 6px 2px 0;
    padding: 0 8px;
    line-height: 30px;
  }

  .tag span {
    margin-right: 3px;
  }
</style>
